@import '../../assets/styles/components.css';

@layer components {
  :host {
    @apply cursor-default text-neutral-dark;
    @apply inline-flex flex-col;
    @apply w-48 gap-y-1;

    abds-icon {
      @apply text-secondary-200;
    }

    abds-label {
      @apply text-neutral-darkest;
    }

    input {
      @apply w-full self-start py-1.5-border text-sm leading-5;
      @apply bg-neutral-lightest text-neutral-dark outline-none autofill:bg-clip-text;
      @apply placeholder:italic placeholder:text-secondary-400;

      &[type='password'] {
        &::-ms-reveal {
          @apply appearance-none hidden;
        }
      }

      &[type='search'] {
        &::-webkit-search-cancel-button,
        &::-webkit-search-decoration {
          @apply appearance-none;
        }
      }
    }

    button {
      @apply duration-150 ease-out transition;
      @apply absolute top-1/2 right-2 -translate-y-1/2;

      @apply rounded-sm;
      @apply py-0;
      @apply leading-[0];

      @apply hover:text-brand-600;
      @apply active:text-brand-700;
      @apply focus:outline-none focus:ring focus:ring-primary-200;

      abds-icon {
        @apply h-4 w-4 text-secondary-400;
      }
    }

    .icon-end {
      @apply text-secondary-400;
    }

    .icon-start {
      @apply mr-1;
    }

    .has-focus {
      @apply ring ring-primary-200;
    }

    &([type="search"][value]:not([value=''])),
    &([type="password"][value]:not([value=''])) {
      .input-container {
        @apply pr-7-border;
      }
    }

    .input-container {
      @apply duration-150 ease-out transition;
      @apply relative;
      @apply flex items-center px-2-border;
      @apply bg-neutral-lightest border border-solid border-secondary-200 rounded;
      @apply hover:border-brand-600;

      &.invalid {
        @apply border-danger;

        .icon-end {
          @apply text-danger;
        }
      }

      &.has-focus {
        @apply border-brand-700;
      }
    }

    &([error]) {
      .input-container {
        @apply border-danger;
      }

      .icon-end {
        @apply text-danger;
      }
    }

    &([error][disabled]),
    &([error][readonly]) {
      .icon-end {
        @apply text-secondary-100;
      }
    }

    &([width='full']),
    &([width='full']) input {
      @apply w-full;
    }

    &([readonly]),
    &([disabled]) {
      .input-container {
        @apply bg-secondary-50 border-secondary-100;
      }

      input {
        @apply bg-secondary-50 text-secondary-400;
      }
    }

    &([disabled]) {
      @apply pointer-events-none;

      abds-label {
        @apply cursor-default;
      }

      .icon-end {
        @apply text-secondary-100;
      }

      &.invalid {
        @apply border-danger;
      }
    }
  }
}
